<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0">Copyright 2026 © enplace All rights reserved.</p>
    </div>

    <div class="col-md-6">
      <p class="pull-right mb-0">A solution build by CARDUMEN</p>
    </div>
  </div>
</div>
